import { lt, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { getBreakpointRangeDefault, isMobileOrTablet } from '@mews-commander/ui';
import { NavbarIconButton } from '../../../components';
import { AssistantChatWindowType } from '../../assistant/chat/components/AssistantChatWindowType';
import { useAssistantChatWindowStore } from '../../assistant';

export const AssistantChatButton = () => {
    const assistantEnabled = useFeatureFlag(FeatureFlag.assistantEnabled);
    const assistantAdvanceSearchEnabled = useFeatureFlag(FeatureFlag.assistantAdvanceSearchEnabled);
    const { setAssistantChatWindowState } = useAssistantChatWindowStore();

    if (!assistantEnabled || !assistantAdvanceSearchEnabled) {
        return null;
    }

    const handleOpenChatWindow = () => {
        const mobileOrTablet = isMobileOrTablet(getBreakpointRangeDefault());
        setAssistantChatWindowState({
            showMewsAssistant: true,
            assistantChatWindowType: mobileOrTablet
                ? AssistantChatWindowType.sidePanel
                : AssistantChatWindowType.sideBar,
        });
    };

    return (
        <NavbarIconButton onClick={handleOpenChatWindow} icon={IconName.AI} title={lt('AssistantChatSidePanelTitle')} />
    );
};
